var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-layout"},[_c('a',{staticClass:"skip-link",attrs:{"href":"#content"}},[_vm._v(_vm._s(_vm.$t('Перейти к основному содержанию')))]),_c('Header'),_c('main',{attrs:{"id":"content","tabindex":"-1"}},[_vm._t("default")],2),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }